

import Vue from 'vue'
import fetchReal from './fetchReal'
import errorHandler from '@/utils/errorHandler'

function finalizationTransformer({affectedId, prematureFinalizationComment}) {
  return {
    id: affectedId,
    premature_finalization_comment: prematureFinalizationComment,
  }
}

export default (finalization, realId) => 
  errorHandler(
    Vue.$http.post('purchase/quantification/close_revi/',
      finalizationTransformer(finalization)))
  .then(response => fetchReal({ id: realId }))




// WEBPACK FOOTER //
// ./src/services/workPlan/finishExecution.js